module.exports = __webpack_public_path__ + "img/abc-news-au.c8f28908.png";